// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./~/_extract-text-webpack-plugin@2.1.2@extract-text-webpack-plugin/loader.js?{"omit":1,"remove":true,"publicPath":"../../"}!./~/_vue-style-loader@3.1.2@vue-style-loader!./~/_css-loader@0.28.11@css-loader?{"minimize":true,"sourceMap":true}!./~/_vue-loader@12.2.2@vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-f2ae79c6","scoped":false,"hasInlineConfig":false}!./~/_vue-loader@12.2.2@vue-loader/lib/selector.js?type=styles&index=1!./src/components/RightPane/RightPane.vue
// module id = 1260
// module chunks = 5